export const ANNOUNCEMENT_TYPE = {
  MAINTENANCE: "Maintenance",
  UPGRADE: "Upgrade",
} as const;

export type AnnouncementType = (typeof ANNOUNCEMENT_TYPE)[keyof typeof ANNOUNCEMENT_TYPE];

export interface Announcement {
  EffectiveDate: string;
  ExpirationDate: string;
  Title: string;
  Message: string;
  Severity: string;
  Id: string;
}

export interface AnnouncementMessage {
  message: string;
  type: AnnouncementType;
  [key: string]: string;
}

export interface UpgradeAnnouncement extends Announcement {
  version: string;
}

export interface AnnouncementsState {
  systemAnnouncements: Announcement[];
  updatedTimestamp?: number;
  upgradeAnnouncements: UpgradeAnnouncement[];
}
